import { render, staticRenderFns } from "./BreakdownRiskRecommendation.vue?vue&type=template&id=68a6c179&scoped=true"
import script from "./BreakdownRiskRecommendation.vue?vue&type=script&lang=js"
export * from "./BreakdownRiskRecommendation.vue?vue&type=script&lang=js"
import style0 from "./BreakdownRiskRecommendation.vue?vue&type=style&index=0&id=68a6c179&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a6c179",
  null
  
)

export default component.exports